module.exports = __webpack_public_path__ + "static/media/peace.add328f3.svg";